import { useMutation } from 'react-query';

import { APIBaseChronos } from '../hosts';
import { ExtractedFactFromImage } from '../types/backend-dto-types';
import useGetFetchConfig, { FetchMethod } from '../useGetFetchConfig';

interface ExtractFactsFromImageRequest {
  imageBase64: string;
}

interface UseExtractFactsFromImageOptions {
  onSuccess?: (data: ExtractedFactFromImage[]) => void;
  onError?: (error: Error) => void;
}

export const useExtractFactsFromImageV2 = (options?: UseExtractFactsFromImageOptions) => {
  const { getFetchConfig } = useGetFetchConfig();

  return useMutation<
    ExtractedFactFromImage[],
    Error,
    { matterId: string; docId: string } & ExtractFactsFromImageRequest
  >({
    mutationFn: async ({ matterId, docId, imageBase64 }) => {
      const fetchConfig = getFetchConfig({
        method: FetchMethod.POST,
        data: {
          imageBase64,
        },
      });

      const response = await fetch(
        `${APIBaseChronos}/api/matters/${matterId}/docs/${docId}/facts-from-image`,
        fetchConfig,
      );

      if (!response.ok) {
        throw new Error('Failed to extract facts from image');
      }

      const data = await response.json();
      return data as ExtractedFactFromImage[];
    },
    onSuccess: (data) => {
      options?.onSuccess?.(data);
    },
    onError: (error) => {
      options?.onError?.(error);
    },
  });
};
